export default "__VITE_ASSET__f6pn9gmN__"